"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customEventPolyFill = void 0;
function customEventPolyFill() {
    (function () {
        if (typeof window.CustomEvent === "function")
            return false;
        var windowObj = window;
        function CustomEvent(typeArg, eventInitDict) {
            eventInitDict = eventInitDict || { bubbles: false, cancelable: false, detail: null };
            var evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(typeArg, eventInitDict.bubbles, eventInitDict.cancelable, eventInitDict.detail);
            return evt;
        }
        windowObj.CustomEvent = CustomEvent;
    })();
}
exports.customEventPolyFill = customEventPolyFill;
//# sourceMappingURL=customevent-ie.js.map
//# sourceMappingURL=module.js.map